// extracted by mini-css-extract-plugin
export default {"counter":"ImageCounter_counter__FE0mA","icon":"ImageCounter_icon__o48yQ","text":"ImageCounter_text__duKSU"};